import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../../media-query';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  content: {
    ...maxContainerWidthStyle,
  },
  innerContent: {
    marginHorizontal: 16,
  },
  image: {
    marginBottom: -16,
    marginTop: mediaQuery.small,
  },
  audioPlayer: {
    paddingBottom: 0,
  },
});
